import * as React from 'react'
import I18n from '../../../../core/i18n'
import { settingsService } from '../../../../core/services'
import { InputText, InputTextArea, Toggle } from '../../../atoms'
import AdminLayoutEdit from '../_layouts/edit'
import FormItem from 'components/atoms/_layouts/FormItem'

interface IProps {
  settings: any
}

const FIELDS = {
  default_site: 'default_site',
  default_title: 'default_title',
  default_description: 'default_description',
  default_keywords: 'default_keywords',
  ga_tracking_id: 'ga_tracking_id',
  skip_identification: 'skip_identification',
  skip_profile: 'skip_profile',
  payment_required: 'payment_required',
  service_rate: 'service_rate',
  withholding_rate: 'withholding_rate',
}

const title = I18n.t('admin.edit', {
  model: I18n.t('setting', { scope: 'activerecord.models' }),
})

const AdminSettingsEdit: React.FC<IProps> = props => {
  const settings = props.settings.reduce((obj, setting) => {
    obj[setting.var] = setting.value
    return obj
  }, {})

  const [checkedPaymentRequired, setCheckedPaymentRequired] = React.useState(
    !!settings.payment_required
  )
  const [checkedSkipIdentification, setCheckedSkipIdentification] = React.useState(
    !!settings.skip_identification
  )
  const [checkedSkipProfile, setCheckedSkipProfile] = React.useState(!!settings.skip_profile)

  const handleSubmit = React.useCallback(async (initialValues, values) => {
    const updatedParams = Object.keys(FIELDS).reduce((acc, cur) => {
      if (initialValues[cur] !== values[cur]) {
        acc[cur] = values[cur]
      }
      return acc
    }, {})

    if (Object.keys(updatedParams).length) {
      await settingsService.updateSetting(updatedParams)
    }

    location.href = '/admin/setting'
  }, [])

  const handleChangePaymentRequired = React.useCallback(e => {
    setCheckedPaymentRequired(e.target.checked)
  }, [])

  const handleChangeSkipIdentification = React.useCallback(e => {
    setCheckedSkipIdentification(e.target.checked)
  }, [])

  const handleChangeSkipProfile = React.useCallback(e => {
    setCheckedSkipProfile(e.target.checked)
  }, [])

  return (
    <AdminLayoutEdit
      model="setting"
      title={title}
      fields={FIELDS}
      indexLink="/admin/setting"
      formItems={
        <>
          <InputTextArea
            name="default_site"
            defaultValue={settings.default_site}
            label="Default site"
          />
          <InputTextArea
            name="default_title"
            defaultValue={settings.default_title}
            label="Default title"
          />
          <InputTextArea
            name="default_description"
            defaultValue={settings.default_description}
            label="Default description"
          />
          <InputTextArea
            name="default_keywords"
            defaultValue={settings.default_keywords}
            label="Default keywords"
          />
          <InputText
            name="ga_tracking_id"
            defaultValue={settings.ga_tracking_id}
            label="Google Analytics Tracking ID"
          />
          <InputText
            name="service_rate"
            defaultValue={settings.service_rate}
            label="Service Rate"
          />
          <InputText
            name="withholding_rate"
            defaultValue={settings.withholding_rate}
            label="Withholding Rate"
          />
          <FormItem label={'Payment Required'} required={false} error={null}>
            <Toggle
              name="payment_required"
              checked={checkedPaymentRequired}
              onChangeHandler={handleChangePaymentRequired}
            />
          </FormItem>
          <FormItem label={'Skip profile'} required={false} error={null}>
            <Toggle
              name="skip_profile"
              checked={checkedSkipProfile}
              onChangeHandler={handleChangeSkipProfile}
            />
          </FormItem>
          <FormItem label={'Skip Identification'} required={false} error={null}>
            <Toggle
              name="skip_identification"
              checked={checkedSkipIdentification}
              onChangeHandler={handleChangeSkipIdentification}
            />
          </FormItem>
        </>
      }
      handleSubmit={handleSubmit}
    />
  )
}

export default AdminSettingsEdit
